import { FormControl, Validators } from '@angular/forms';
import {
  EoCustomControlConfig,
  EoDropdownComponent,
  EoDropdownConfig,
  EoFormPanelConfig,
  EoInputConfig,
} from 'ngx-eo-web-components';
import { months } from '../../shared/components/month-dropdown/month-dropdown.config';
import { generateYearOptions } from '../../shared/components/year-options/year-options.config';


export const hospitalAvailabilityFormPanel = new EoFormPanelConfig({
  name: 'hospitalAvailability',
  panelContentStyleClass: 'grid',
  config: [
    new EoDropdownConfig({
      name: 'availabilityMonth',
      label: 'Μήνας',
      placeholder: 'Επιλέξτε ένα μήνα',
      styleClass: 'col-6',
      options: months,
      optionLabel: 'label',
      optionValue: 'value',
      appendTo: 'body',
      control: new FormControl(null, [Validators.required]),
    }),
    new EoDropdownConfig({
      name: 'availabilityYear',
      label: 'Έτος',
      placeholder: 'Επιλέξτε ένα έτος',
      styleClass: 'col-6',
      options: generateYearOptions(5),
      optionLabel: 'label',
      optionValue: 'value',
      appendTo: 'body',
      control: new FormControl(null, [Validators.required]),
    }),
    new EoInputConfig({
      name: 'slots',
      styleClass: 'col-6',
      type: 'number',
      label: 'Αριθμός Χειρουργείων',
      placeholder: 'Παρακαλώ συμπληρώστε τον αριθμό χειρουργείων',
      control: new FormControl('', [Validators.required]),
    }),
    new EoCustomControlConfig({
      name: 'clinicID',
      label: 'Κλινική',
      styleClass: 'col-6',
      control: new FormControl(null),
    }),
  ],
});

export const hospitalAvailabilityFormConfig: EoFormPanelConfig[] = [hospitalAvailabilityFormPanel];
